import customFetchBase from "../../../../principal/customFetchBase";
import { createApi } from "@reduxjs/toolkit/query/react";

export const firmaCursosApi = createApi({
  reducerPath: "firmaCursosApi",
  baseQuery: customFetchBase,
  tagTypes: ["FirmaCursos"],
  endpoints: () => ({}),
});
